import React, {useLayoutEffect} from "react";
import _ from "lodash";

import * as am5 from "@amcharts/amcharts5";
import * as am5map from "@amcharts/amcharts5/map";
import italianProvincesGeodata from "@amcharts/amcharts5-geodata/italyProvincesLow";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";


function UsersHeatMap({id, data}) {

  useLayoutEffect(() => {

    am5.addLicense("AM5M328990290"); // amcharts map license

    let root = am5.Root.new(id);
    root.setThemes([am5themes_Animated.new(root)]);

    // Create chart
    let chart = root.container.children.push(
      am5map.MapChart.new(root, {
        panX: "rotateX",
        projection: am5map.geoMercator(),
        layout: root.horizontalLayout,
      })
    );

    let italySeries = chart.series.push(
      am5map.MapPolygonSeries.new(root, {
        geoJSON: italianProvincesGeodata,
        exclude: ["FR-H", "MT"], // Exclude Corsica and Malta
        calculateAggregates: true,
        valueField: "value", // This is the field that must match with the HeatMapSampleData value key
        fill: am5.color("#d9d9d9"),
      })
    );

    // Enable hover functionality
    italySeries.mapPolygons.template.setAll({
      tooltipText: "[bold]{name}[/]: {value}",
      interactive: true, // nonScalingStroke: true,
      strokeWidth: 0.5,
    });

    // Set hover fill color
    italySeries.mapPolygons.template.states.create("hover", {
      fill: am5.color("#f8f8f8"),
    });

    // Set Heatmap colors
    italySeries.set("heatRules", [
      {
        target: italySeries.mapPolygons.template,
        dataField: "value",
        min: am5.Color.brighten(am5.color("#afcdaf"), 0),
        max: am5.Color.brighten(am5.color("#698c65"), -0.5),
        key: "fill",
      },
    ]);

    // Add heat map data
    italySeries.data.setAll(data);

    return () => {
      root.dispose();
    };
  }, [data, id]); // eslint-disable-line react-hooks/exhaustive-deps

  return <div id={id} className="w-full h-96"/>;
}

export default React.memo(UsersHeatMap, (props, nextProps) => {
  return _.isEqual(props.data, nextProps.data);
});
